import React, { Component } from "react";
import { connect } from "react-redux";
import { getEmployees } from "../../reducer";
import { Form } from "semantic-ui-react";
import propTypes from "prop-types";
import { Translate } from "react-localize-redux";

class EmployeeSelect extends Component {

    prepareEmployees() {
        if (this.props.employees === null || typeof this.props.employees === 'undefined') {
            return [];
        }
        const employees = this.props.employees
            .map((employee) => (
            {key: employee.id, value: employee.id, text: employee.name}
        ));

        if(this.props.additionalEmployees !== null && typeof this.props.additionalEmployees !== 'undefined'){
            this.props.additionalEmployees.forEach((element)=>{
                employees.unshift(element);
            });

        }

        return employees;
    }

    render() {

        return (
            <Translate>
                {
                    ({translate}) =>
                        <Form.Select
                            search
                            selection
                            fluid
                            label={translate('clock.employee.label')}
                            options={this.prepareEmployees()}
                            value={this.props.value}
                            onChange={(e, {value}) => {
                                this.props.onChange(value)
                            }}
                            required
                        />
                }
            </Translate>
        )
    }

}

EmployeeSelect.propTypes = {
    onChange: propTypes.func,
    value: propTypes.number,
    additionalEmployees: propTypes.array,
};

const mapStateToProps = state => ({
    employees: getEmployees(state),
});


// No need to connect()!
export default connect(
    mapStateToProps
)(EmployeeSelect)



// WEBPACK FOOTER //
// ./src/scenes/Clock/components/EmployeeSelect/index.js